import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';
import * as bomLibAction from '../../BomLibrary/store/BomLibrary.action';
import * as customModuleAction from '../Store/CustomModule.action';
import * as uploaderAction from '../../../UploaderRedux/store/uploader.action';
import SectionControl from './SectionControl';
import { useCustomModuleState } from '../Context/index';
import ModuleBuilder from './ModuleBuilder';
import ConfigModal from './ControlConfig/ConfigModal';
import '../CustomModule.css';
import DragDropSort from '../../../../Components/DragDropSort/DragDropSort';
import FilePreview from '../../../../Components/FilePreview/FilePreview';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { createOptions, customStylesWhite } from '../../../../Components/helper';

function AddEdit() {
  const reducer = useSelector((reducerstate) => reducerstate);
  const { UserDetails, SystemMastersDetails, BomLibraryDetails, CustomModuleReducer } = reducer;
  const { brandList, pcTypeList, multiSubBrandList, subBrandAccess } = SystemMastersDetails;
  const { ReferenceSupplier } = BomLibraryDetails;
  const { customLibraryDetail, customModulePageList } = CustomModuleReducer;
  const { userInfo } = UserDetails;
  const { customModuleState, setCustomModuleState, toggleEditPopup, initialState } = useCustomModuleState();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { moduleLibId } = useParams();
  const history = useHistory();
  const { editPopup, editpopupChildData, editPopupIndex, disableDrag, controlPanelOpen } = customModuleState;
  const uniqueKey = uuidv4();
  const libRef = useRef(null);
  const [showFilePreviewModal, setFilePreviewModal] = useState(false);
  const [selectedFileToPreview, setFileToPreview] = useState(null);
  const [subBrandOptions, setSubBrandOptions] = useState([]);
  const [state, setState] = useState({
    isEditModeOn: false,
    pageLoading: false,
    reArrange: false,
    isGrdiVisible: true,
    selectedPage: null,
    errorFields: [],
    libraryAllData: {
      pages: [],
    },
    libraryPageList: [],
    isNewPageAdding: false,
    loadingPreview: false,
    previewLoader: false,
    previewPageId: null,
  });
  const {
    loadingPreview,
    isEditModeOn,
    pageLoading,
    reArrange,
    isGrdiVisible,
    libraryAllData,
    selectedPage,
    libraryPageList,
    errorFields,
    isNewPageAdding,
    previewLoader,
    previewPageId,
  } = state;
  const brandsOptions = brandList?.map((ele) => ({
    label: ele.name,
    value: ele._id,
  }));
  const productTypeOptions = pcTypeList?.map((ele) => ({
    label: ele.name,
    value: ele._id,
  }));

  const updateParentState = (newValue) => {
    setState((prevState) => {
      const updatedPages = [...prevState.libraryAllData.pages];
      updatedPages[0] = {
        ...updatedPages[0],
        grid: newValue,
      };

      return {
        ...prevState,
        libraryAllData: {
          ...prevState.libraryAllData,
          pages: updatedPages,
        },
      };
    });
  };

  useEffect(() => {
    if (multiSubBrandList?.length > 0) {
      setSubBrandOptions(createOptions(multiSubBrandList, 'name', '_id'));
    }
  }, [multiSubBrandList]);

  const refreshPageList = async () => {
    return dispatch(customModuleAction.getCMPageList(moduleLibId));
  };

  useEffect(() => {
    const getLibraryData = async () => {
      await refreshPageList();
    };
    if (moduleLibId) {
      setState((prevState) => ({
        ...prevState,
        isEditModeOn: true,
        pageLoading: true,
      }));
      getLibraryData();
    }
  }, [moduleLibId]);
  useEffect(() => {
    const getSubBrandAccess = async () => {
      await dispatch(systemMasterAction.getSubBrandAccess());
    };
    getSubBrandAccess();
  }, []);

  const savePageOnS3 = async (pagesData, libData, isHeadingAdded) => {
    libData.pages = libData?.pages?.map((page) => {
      const pageObj = {
        pageKey: page?.pageKey || `pages_${page?._id}`,
        pageTitle: page?.pageTitle,
        sequence: page?.sequence,
        orientation: page?.orientation,
        isContentAdded: isHeadingAdded?.length > 0,
        hasDependentControl: libData?.hasDependentControl || false,
        hasSourceControl: libData?.hasSourceControl || false,
        hasCalculationControl: libData?.hasCalculationControl || false,
        hasImageControl: libData?.hasImageControl || false,
        _id: page?._id,
      };
      if (page?.isContectPage) {
        pageObj.isContectPage = page?.isContectPage;
        pageObj.contentTable = page?.contentTable || [];
      }
      if (page?.isPageDuplicated) {
        pageObj.isPageDuplicated = page?.isPageDuplicated;
        pageObj.refPageId = page?.refPageId || '';
      }
      return pageObj;
    });
    const filterDataTable = pagesData[0].grid.filter((ele) => ele?.control && ele.control.key === 'Table');
    if (filterDataTable.length > 0) {
      filterDataTable.forEach((dataItem) => {
        const index = pagesData[0].grid.findIndex((ele) => ele === dataItem);
        if (index !== -1) {
          pagesData[0].grid[index].isResizable = true;
          pagesData[0].grid[index].minH = 2;
        }
      });
    }
    return await dispatch(uploaderAction.customModulePages(pagesData, 'CustomModule', t, { folderId: moduleLibId, dbObject: libData }));
  };

  const getSelectedPageData = async (pageData) => {
    setState((prevState) => ({
      ...prevState,
      pageLoading: true,
    }));

    let libCMLocalStorage = {
      type: 'library',
      moduleLibId,
    };

    let res = null;
    if (pageData?.isContectPage) {
      libCMLocalStorage = { ...libCMLocalStorage, isContectPage: true };
      localStorage.setItem('cmLibraryData', JSON.stringify(libCMLocalStorage));
      res = await dispatch(customModuleAction.getLibraryCMContentPage(moduleLibId));
    } else {
      res = await dispatch(customModuleAction.getCustomModuleById(moduleLibId, pageData?._id));
      libCMLocalStorage = { ...libCMLocalStorage, pageId: pageData?._id, pageTitle: res?.data?.pages[0]?.pageTitle, isContectPage: false };
      localStorage.setItem('cmLibraryData', JSON.stringify(libCMLocalStorage));
    }
    if (res?.code === 200) {
      setState((prevState) => ({
        ...prevState,
        pageLoading: false,
        selectedPage: pageData,
      }));
    }
  };
  useEffect(() => {
    if (customModulePageList?.pages?.length > 0 && isEditModeOn && !isNewPageAdding) {
      const updatedPageName = selectedPage && customModulePageList?.pages?.find((ele) => ele?._id === selectedPage?._id);
      const cmLocalStorage = JSON.parse(localStorage.getItem('cmLibraryData'));
      if (!isEmpty(cmLocalStorage) && cmLocalStorage?.moduleLibId === moduleLibId) {
        const lastVisitedPage = cmLocalStorage?.isContectPage
          ? customModulePageList?.pages?.find((ele) => ele?.isContectPage === true)
          : customModulePageList?.pages?.find((ele) => ele?._id === cmLocalStorage?.pageId);
        if (lastVisitedPage) getSelectedPageData(lastVisitedPage);
      } else {
        getSelectedPageData(updatedPageName || customModulePageList?.pages[0]);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        pageLoading: false,
      }));
    }
  }, [customModulePageList?.pages?.length, isEditModeOn]);

  useEffect(() => {
    const pagesCopy = cloneDeep(customModulePageList?.pages);
    setState((prevState) => ({
      ...prevState,
      libraryPageList: pagesCopy,
      selectedPage: selectedPage && customModulePageList?.pages?.find((ele) => ele?._id === selectedPage?._id),
    }));
  }, [customModulePageList, isEditModeOn]);

  useEffect(() => {
    if (customLibraryDetail?._id) {
      setCustomModuleState((prevState) => ({
        ...prevState,
        rigthColumn: customLibraryDetail,
      }));
      setState((prevState) => ({
        ...prevState,
        libraryAllData: customLibraryDetail ? { ...customLibraryDetail } : {},
      }));
    }
  }, [customLibraryDetail]);

  useEffect(() => {
    const init = async () => {
      await Promise.all([
        dispatch(
          systemMasterAction.getPCTypesDetails({
            loggedInUserId: userInfo?.userId,
            isActive: true,
            tier: 'Tier1',
          }),
        ),

        dispatch(
          systemMasterAction.getBrandDetails({
            loggedInUserId: userInfo?.userId,
            isActive: 1,
          }),
        ),
        dispatch(bomLibAction.fetchBomReferenceSupplier()),
      ]);
    };

    init();
    return () => {
      dispatch(customModuleAction.unmountLibrary());
      localStorage.removeItem('cmLibraryData');
      setState((prevState) => ({
        ...prevState,
        selectedPage: null,
        errorFields: [],
        libraryAllData: {
          pages: [],
        },
      }));
      setCustomModuleState(() => ({
        ...initialState,
      }));
    };
  }, [dispatch]);

  const getStaticGrid = async () => {
    return Array.from({ length: 500 }, (_, i) => ({
      i: i.toString(),
      x: i % 10, // x position (0 to 9, repeats after 9)
      y: Math.floor(i / 10), // y position (0 to 4)
      w: 1, // width of grid item
      h: 1, // height of grid item
    }));
  };

  const checkTableHasCalculation = (ele) => {
    if (ele?.control?.key === 'Table') {
      return ele?.control?.tableColumns?.some((column) => column?.key === 'Calculation');
    }
    return false;
  };

  const autoSaveCurrentPage = async () => {
    if (libraryAllData?.pages?.length > 0) {
      setState((prevState) => ({
        ...prevState,
        pageLoading: true,
      }));
      const moduleData = cloneDeep({ ...libraryAllData });
      moduleData.productTypeId = moduleData?.productTypeId?.map((item) => item.value);
      moduleData.brandId = moduleData?.brandId?.map((item) => item.value);
      moduleData.supplierId = moduleData?.supplierId?.map((item) => item.value);
      if (moduleData?.subBrandId?.length > 0) {
        moduleData.subBrandId = moduleData?.subBrandId?.map((item) => item.value);
      }
      const activeGrid = libRef.current.getActivePageData();

      let clonedPages = cloneDeep(libraryAllData?.pages);
      clonedPages = clonedPages.map((page) => {
        return {
          ...page,
          grid: activeGrid || [],
        };
      });
      const isHeadingAdded = activeGrid?.filter((ele) => ele?.control && ele.control?.key === 'Heading');
      moduleData.hasDependentControl = activeGrid?.some((ele) => ['Dropdown', 'Number_Decimal', 'Number_Percentage'].includes(ele?.control?.key));
      moduleData.hasSourceControl = activeGrid?.some((ele) => ele?.control?.key === 'Source');
      moduleData.hasCalculationControl = activeGrid?.some((ele) => ele?.control?.key === 'Calculation' || checkTableHasCalculation(ele));
      moduleData.hasImageControl = activeGrid?.some((ele) => ele?.control?.key === 'Image');
      return savePageOnS3(clonedPages, moduleData, isHeadingAdded);
    }
    return true;
  };

  const handleChangePage = async (value) => {
    if (selectedPage?._id !== value?._id) {
      setState((prevState) => ({
        ...prevState,
        pageLoading: true,
      }));
      let libCMLocalStorage = {
        type: 'library',
        moduleLibId,
      };
      const response = await autoSaveCurrentPage();
      if (response) {
        setState((prevState) => ({
          ...prevState,
          errorFields: [],
          libraryAllData: {
            pages: [],
          },
        }));
        let res = null;
        if (value.isContectPage) {
          res = await dispatch(customModuleAction.getLibraryCMContentPage(moduleLibId));
          libCMLocalStorage = { ...libCMLocalStorage, isContectPage: true };
          localStorage.setItem('cmLibraryData', JSON.stringify(libCMLocalStorage));
        } else {
          res = await dispatch(customModuleAction.getCustomModuleById(moduleLibId, value?._id));
          libCMLocalStorage = { ...libCMLocalStorage, pageId: value?._id, pageTitle: value?.pageTitle, isContectPage: false };
          localStorage.setItem('cmLibraryData', JSON.stringify(libCMLocalStorage));
        }

        if (res.code === 200) {
          setState((prevState) => ({
            ...prevState,
            pageLoading: false,
            selectedPage: value,
          }));
        }
      }
    }
  };

  const handleTitleChange = (textValue, pageIndex) => {
    const updatedPages = [...libraryAllData.pages];
    updatedPages[pageIndex] = {
      ...updatedPages[pageIndex],
      pageTitle: textValue,
    };

    // Set the new state with the updated pages array
    setState((prevState) => ({
      ...prevState,
      libraryAllData: {
        ...prevState.libraryAllData,
        pages: updatedPages,
      },
    }));
  };

  const isPageSaved = async (newId) => {
    const pageData = customModulePageList?.pages?.filter((ele) => ele?._id === newId);
    return pageData?.length > 0;
  };

  const handleDuplicatePage = async (index) => {
    const clonedLibraryData = cloneDeep(state?.libraryAllData);
    const pageCopy = { ...clonedLibraryData.pages[index] };
    const response = await isPageSaved(pageCopy._id);
    const findCopyIndex = libraryPageList.findIndex((ele) => ele?._id === pageCopy._id);
    if (response) {
      const activeGrid = libRef.current.getActivePageData();
      // Create a copy of the page object
      const newId = await dispatch(customModuleAction.getNewMongoId());

      // Set unique properties for the new page
      pageCopy.refPageId = pageCopy._id;
      pageCopy.uniqueKey = uniqueKey;
      pageCopy._id = newId;
      pageCopy.pageTitle += ' Copy';
      pageCopy.grid = activeGrid || [];
      pageCopy.isPageDuplicated = true;
      pageCopy.pageKey = `pages_${newId}`;
      // Remove the old page object at the specified index
      clonedLibraryData.pages.splice(index, 1);

      // Add the new page object at the same index
      clonedLibraryData.pages.splice(index, 0, pageCopy);
      setState((prevState) => {
        // Update the state with the modified libraryAllData
        const newLibraryPageList = [...(prevState.libraryPageList || [])];

        newLibraryPageList.splice(findCopyIndex + 1, 0, { ...pageCopy, grid: [] });

        return {
          ...prevState,
          libraryAllData: clonedLibraryData,
          libraryPageList: newLibraryPageList,
          selectedPage: { ...pageCopy, grid: [] },
        };
      });
    } else {
      toasterMsg(t('CUSTOM_MODULE.DUPLICATE_PAGE_VALIDATION'), 'danger');
    }
  };

  const handlePageDelete = async (index) => {
    const clonedLibraryData = cloneDeep(libraryAllData);
    const deletePage = clonedLibraryData?.pages[index];
    if (deletePage?.pageKey) {
      const deleteParams = { libId: moduleLibId, page: { _id: deletePage._id, pageKey: deletePage.pageKey } };
      await dispatch(customModuleAction.deleteCustomLibraryPage(deleteParams, t));
      refreshPageList();
    }
    clonedLibraryData.pages.splice(index, 1);
    const updatedLibraryPageList = libraryPageList.filter((ele) => ele?._id !== deletePage?._id);
    const newSelectedPage = updatedLibraryPageList.length > 0 ? updatedLibraryPageList[0] : null;
    localStorage.removeItem('cmLibraryData');
    setState((prevState) => ({
      ...prevState,
      libraryAllData: clonedLibraryData,
      libraryPageList: libraryPageList.filter((ele) => ele?._id !== deletePage?._id),
      selectedPage: newSelectedPage,
    }));
    getSelectedPageData(newSelectedPage);
  };

  const isValidForm = (formData) => {
    const errorFields = [];
    if (formData?.moduleName === null || isEmpty(formData?.moduleName)) {
      errorFields.push('moduleName');
    }
    if (formData?.productTypeId === null || isEmpty(formData?.productTypeId)) {
      errorFields.push('productTypeId');
    }
    if (formData?.brandId === null || isEmpty(formData?.brandId)) {
      errorFields.push('brandId');
    }
    if (formData?.supplierId === null || isEmpty(formData?.supplierId)) {
      errorFields.push('supplierId');
    }

    if (formData?.pages?.length > 0) {
      formData?.pages?.forEach((page) => {
        if (page?.pageTitle === '') {
          errorFields.push('pageTitle');
          toasterMsg(t('CUSTOM_MODULE.PAGE_TITLE_REQUIRED'), 'danger');
        }
      });
    } else {
      errorFields.push('pages');
      toasterMsg(t('CUSTOM_MODULE.ONE_PAGE_REQUIRED'), 'danger');
    }

    setState((prevState) => ({
      ...prevState,
      errorFields,
    }));

    return errorFields.length <= 0;
  };

  const addEditModule = async () => {
    const basicData = await libRef.current.getBasicLibraryData();
    const moduleData = cloneDeep({ ...libraryAllData, ...basicData });
    if (isValidForm(moduleData)) {
      const activeGrid = libRef.current.getActivePageData();
      let clonedPages = cloneDeep(libraryAllData?.pages);
      clonedPages = clonedPages.map((page) => {
        return {
          ...page,
          grid: activeGrid || [],
        };
      });
      const isHeadingAdded = activeGrid?.filter((ele) => ele?.control && ele.control?.key === 'Heading');
      moduleData.moduleName = basicData?.moduleName;
      moduleData.productTypeId = basicData?.productTypeId?.map((item) => item.value);
      moduleData.brandId = basicData?.brandId?.map((item) => item.value);
      if (moduleData?.subBrandId?.length > 0) {
        moduleData.subBrandId = moduleData?.subBrandId?.map((item) => item.value);
      }
      moduleData.supplierId = basicData?.supplierId?.map((item) => item.value);
      moduleData.hasDependentControl = activeGrid?.some((ele) => ['Dropdown', 'Number_Decimal', 'Number_Percentage'].includes(ele?.control?.key));
      moduleData.hasSourceControl = activeGrid?.some((ele) => ele?.control?.key === 'Source');
      moduleData.hasCalculationControl = activeGrid?.some((ele) => ele?.control?.key === 'Calculation' || checkTableHasCalculation(ele));
      moduleData.hasImageControl = activeGrid?.some((ele) => ele?.control?.key === 'Image');
      if (isEditModeOn && !pageLoading) {
        setState((prevState) => ({
          ...prevState,
          pageLoading: true,
        }));
        await savePageOnS3(clonedPages, moduleData, isHeadingAdded);

        setState((prevState) => ({
          ...prevState,
          pageLoading: false,
        }));
      } else if (!pageLoading) {
        setState((prevState) => ({
          ...prevState,
          pageLoading: true,
        }));
        const res = await savePageOnS3(clonedPages, moduleData, isHeadingAdded);

        if (res) {
          history.push(`/libraries/custom-module/library/edit/${res?.insertedId?._id || res?.data?._id}`);
        }
        setState((prevState) => ({
          ...prevState,
          pageLoading: false,
        }));
      }
      updateParentState(activeGrid);
    }
  };
  const handleGridSHowHide = async () => {
    setState((prevState) => ({
      ...prevState,
      isGrdiVisible: !isGrdiVisible,
    }));
  };
  const handleDragOnOff = async () => {
    setCustomModuleState((prevState) => ({
      ...prevState,
      disableDrag: !disableDrag,
    }));
  };

  const handleShowRearrangeModal = () => {
    if (state?.selectedPage?.pageKey && !state?.selectedPage?.isPageDuplicated) {
      setState((prevState) => ({
        ...prevState,
        reArrange: !reArrange,
      }));
    } else {
      toasterMsg(t('CUSTOM_MODULE.PAGE_SAVE_CURRENT'), 'danger');
    }
  };
  const handleSaveSequence = async (_e, sequenceList) => {
    const objData = {
      pages: sequenceList?.sequence || [],
    };
    const res = await dispatch(customModuleAction.updatePageSequence(objData, moduleLibId, t));
    if (res?.code === 200) {
      refreshPageList();
      handleShowRearrangeModal();
    }
  };

  async function handleSampleDownload() {
    await dispatch(customModuleAction.downloadSampleFile());
  }

  const handlePreview = async () => {
    const openFilePreview = (doc) => {
      const params = {
        fileName: 'Template Preview',
        mimeType: 'application/pdf',
        path: doc,
      };
      setFileToPreview(params);
      setFilePreviewModal(true);
    };

    const objDataPreview = {
      moduleLibId,
      pageId: selectedPage?._id,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      moduleName: 'custom-module',
      previewFrom: 'library',
    };
    setState((prevState) => ({
      ...prevState,
      loadingPreview: true,
      previewPageId: selectedPage?._id,
    }));
    const response = await dispatch(customModuleAction.previewSampleFile(objDataPreview));
    setState((prevState) => ({
      ...prevState,
      loadingPreview: false,
    }));
    if (response?.data?.zipUrl) {
      openFilePreview(response.data.zipUrl);
    }
  };

  const saveConfigData = (obj, i) => {
    const libraryAllDataClone = JSON.parse(JSON.stringify(libraryAllData));
    const cloneObj = cloneDeep(obj);
    const activeGrid = libRef.current.getActivePageData();
    let clonedPages = cloneDeep(libraryAllData?.pages);

    clonedPages = clonedPages.map((page) => {
      return {
        ...page,
        grid: activeGrid || [],
      };
    });

    if (customModuleState.editPopupPageIndex !== -1) {
      if (customModuleState.editPopupGridIndex !== -1) {
        clonedPages[customModuleState?.editPopupPageIndex].grid[customModuleState?.editPopupGridIndex].control = cloneObj;
      } else {
        clonedPages[customModuleState?.editPopupPageIndex] = cloneObj;
      }
    }

    // Update libraryAllDataClone with the modified clonedPages
    libraryAllDataClone.pages = clonedPages;

    setState((prevState) => ({
      ...prevState,
      libraryAllData: libraryAllDataClone,
    }));
    setCustomModuleState((oldData) => ({
      ...oldData,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupPageIndex: -1,
      editPopupGridIndex: -1,
    }));
  };

  const handleExpand = () => {
    setCustomModuleState((prevState) => ({
      ...prevState,
      controlPanelOpen: !controlPanelOpen,
    }));
  };

  const getNextPage = async () => {
    const currentIndex = libraryPageList?.findIndex((page) => page.pageKey === selectedPage?.pageKey);
    if (currentIndex === -1 || currentIndex === libraryPageList?.length - 1) {
      toasterMsg(t('CUSTOM_MODULE.NO_PAGE'), 'danger');
    } else {
      const res = await autoSaveCurrentPage();
      if (res) {
        const pageData = libraryPageList[currentIndex + 1];
        getSelectedPageData(pageData);
      }
    }
  };

  const getPrevPage = async () => {
    const currentIndex = libraryPageList?.findIndex((page) => page.pageKey === selectedPage.pageKey);
    if (currentIndex <= 0) {
      toasterMsg(t('CUSTOM_MODULE.NO_PAGE'), 'danger');
    } else {
      const res = await autoSaveCurrentPage();
      if (res) {
        const pageData = libraryPageList[currentIndex - 1];
        getSelectedPageData(pageData);
      }
    }
  };

  const checkNewPage = () => {
    if (libraryAllData?.pages?.length > 0) {
      toasterMsg(t('CUSTOM_MODULE.SAVE_LIBRARY_VALIDATION'), 'danger');
      return false;
    }
    return true;
  };
  const handleAddCanvas = async (pageOrientation) => {
    setState((prevState) => ({
      ...prevState,
      pageLoading: true,
      isNewPageAdding: true,
    }));
    const response = isEditModeOn ? await autoSaveCurrentPage() : checkNewPage();

    if (response) {
      const libraryAllDataClone = cloneDeep(libraryAllData);
      const newId = await dispatch(customModuleAction.getNewMongoId());

      // Generate layout
      if (pageOrientation === 'content_page' && libraryPageList?.length > 0) {
        const objContent = {
          uniqueKey,
          pageTitle: 'Content Page',
          sequence: 0,
          contentTable: [],
          isContectPage: true,
          _id: newId,
        };
        const res = await dispatch(customModuleAction.getContentPageData(moduleLibId));

        if (res?.code === 200) {
          objContent.contentTable = res?.data?.pages?.length > 0 ? res.data.pages[0]?.contentTable : [];
        }

        setState((prevState) => ({
          ...prevState,
          libraryPageList: [objContent, ...(prevState.libraryPageList || [])],
          selectedPage: objContent,
        }));

        libraryAllDataClone.pages = [objContent];
      } else if (pageOrientation !== 'content_page') {
        const initialLayout = await getStaticGrid();
        const objNewLayout = {
          uniqueKey,
          pageTitle: t('CUSTOM_MODULE.PAGE_TITLE_PLACEHOLDER'),
          sequence: (customModulePageList?.pages?.length || 0) + 1,
          orientation: pageOrientation === 'portrait_page' ? 'portrait' : 'landscape',
          grid: [...initialLayout],
          _id: newId,
        };
        setState((prevState) => ({
          ...prevState,
          libraryPageList: [...(prevState.libraryPageList || []), { ...objNewLayout, grid: [] }],
          selectedPage: { ...objNewLayout, grid: [] },
        }));
        libraryAllDataClone.pages = [objNewLayout];
      } else {
        toasterMsg(t('CUSTOM_MODULE.NO_PAGE_AVAILABLE'), 'danger');
        setState((prevState) => ({
          ...prevState,
          pageLoading: false,
        }));
        return;
      }
      setState((prevState) => ({
        ...prevState,
        libraryAllData: libraryAllDataClone,
      }));
    }
    setState((prevState) => ({
      ...prevState,
      pageLoading: false,
      isNewPageAdding: false,
    }));
  };

  const handlePreviewChangePage = async (pageData) => {
    const openFilePreview = (doc) => {
      const params = {
        fileName: 'Template Preview',
        mimeType: 'application/pdf',
        path: doc,
      };
      setFileToPreview(params);
    };

    const objDataPreview = {
      moduleLibId,
      pageId: pageData?._id,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      moduleName: 'custom-module',
      previewFrom: 'library',
    };
    setState((prevState) => ({
      ...prevState,
      previewLoader: true,
      previewPageId: pageData?._id,
    }));
    const response = await dispatch(customModuleAction.previewSampleFile(objDataPreview));
    setState((prevState) => ({
      ...prevState,
      previewLoader: false,
    }));
    if (response?.data?.zipUrl) {
      openFilePreview(response.data.zipUrl);
    }
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('CUSTOM_MODULE.PAGE_TITLE')}</h4>
          <span className="mx-3">|</span>
          <div className="w-300px">
            <Select
              name="country"
              options={libraryPageList}
              getOptionLabel={({ pageTitle }) => `${pageTitle}`}
              getOptionValue={({ _id }) => `${_id}`}
              value={selectedPage}
              onChange={handleChangePage}
              styles={customStylesWhite}
              isDisabled={pageLoading}
              placeholder={t('CUSTOM_MODULE.SELECT_LIB_PAGE')}
            />
          </div>
        </div>

        <div className="search-filter care-library-filter">
          <button aria-label="Preview" className="filter-btn" type="button" disabled={loadingPreview || pageLoading || !isEditModeOn} onClick={handlePreview}>
            {loadingPreview ? <i className="fa fa-spinner fa-spin" /> : <i title={t('CUSTOM_MODULE.PREVIEW')} className="icon-PDF-Preview f-22" />}
          </button>

          <button aria-label="Download" className="filter-btn" type="button" onClick={handleSampleDownload}>
            <i title={t('CUSTOM_MODULE.DOWNLOAD')} className="icon-Download f-24" />
          </button>
          <button type="button" onClick={() => handleDragOnOff()} className="btn btn-white btn-back-lib mb-0">
            {t('CUSTOM_MODULE.DRAG')} {disableDrag ? t('CUSTOM_MODULE.OFF') : t('CUSTOM_MODULE.ON')}
          </button>
          <button type="button" onClick={() => handleGridSHowHide()} className="btn btn-white btn-back-lib mb-0">
            {isGrdiVisible ? t('CUSTOM_MODULE.HIDE') : t('CUSTOM_MODULE.SHOW')} {t('CUSTOM_MODULE.GRID')}
          </button>
          {libraryPageList?.length > 1 && (
            <button className="show-button ml-1" type="button" name="Rearrange" title="Rearrange" onClick={handleShowRearrangeModal} aria-label="Rearrange">
              <i className="icon-expand m-1" />
            </button>
          )}

          <button className="show-button ml-1" type="button" name="Setting" title="Page Control" onClick={handleExpand} aria-label="Rearrange">
            <i className="icon-configuration f-18 m-1" />
          </button>
          <button type="button" onClick={() => addEditModule()} className="btn btn-white btn-back-lib mb-0">
            {isEditModeOn ? t('CUSTOM_MODULE.UPDATE') : t('CUSTOM_MODULE.SAVE')}
          </button>
          <Link className="btn btn-white btn-back-lib mb-0 text-decoration-none" to="/libraries/custom-module/library">
            {isEditModeOn ? t('CUSTOM_MODULE.BACK') : t('CUSTOM_MODULE.CANCEL')}
          </Link>
        </div>
      </div>

      <Container className="p-0 position-relative overflow-hidden h-100" fluid>
        <DndProvider backend={HTML5Backend}>
          <div className="add-edit-container h-100">
            <SectionControl pageLoading={pageLoading} handleAddCanvas={handleAddCanvas} customModulePageList={customModulePageList} />

            <ModuleBuilder
              ref={libRef}
              libraryAllData={libraryAllData}
              errorFields={errorFields}
              brandsOptions={brandsOptions}
              allSupplierList={ReferenceSupplier}
              productTypeOptions={productTypeOptions}
              isGrdiVisible={isGrdiVisible}
              handleDuplicatePage={handleDuplicatePage}
              handlePageDelete={handlePageDelete}
              handleTitleChange={handleTitleChange}
              pageLoading={pageLoading}
              pageId={selectedPage?._id}
              isSubBrandAccess={subBrandAccess}
              subBrandOptions={subBrandOptions}
              setSubBrandOptions={setSubBrandOptions}
            />
            {libraryPageList?.length > 1 && (
              <>
                <button disabled={pageLoading} className={`${controlPanelOpen && 'open'} btn btn-next-prev btn-prev`} onClick={getPrevPage} type="button">
                  <span className="sr-only">Prev</span>
                  <span className="icon-new-down-arrow-icon" />
                </button>
                <button disabled={pageLoading} className="btn btn-next-prev btn-next" onClick={getNextPage} type="button">
                  <span className="sr-only">Next</span>
                  <span className="icon-new-down-arrow-icon" />
                </button>
              </>
            )}
          </div>
        </DndProvider>
        {editPopup && (
          <ConfigModal
            show={editPopup}
            toggle={toggleEditPopup}
            data={editpopupChildData}
            dataIndex={editPopupIndex}
            setCustomModuleState={setCustomModuleState}
            submit={saveConfigData}
          />
        )}
        {reArrange && (
          <DragDropSort
            isShow={reArrange}
            isToggle={handleShowRearrangeModal}
            fromComp="customModule"
            itemList={customModulePageList?.pages}
            saveSequence={handleSaveSequence}
          />
        )}
      </Container>
      {showFilePreviewModal && (
        <FilePreview
          onOpen={showFilePreviewModal}
          pageList={libraryPageList}
          fileObj={selectedFileToPreview}
          toggle={() => setFilePreviewModal(!showFilePreviewModal)}
          handlePreviewChangePage={handlePreviewChangePage}
          previewLoader={previewLoader}
          previewPageId={previewPageId}
        />
      )}
    </>
  );
}

export default AddEdit;
